import { render, staticRenderFns } from "./DialogDetail.vue?vue&type=template&id=bf8d6d94&"
import script from "./DialogDetail.vue?vue&type=script&lang=ts&"
export * from "./DialogDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports